
import { computed, defineComponent, ref } from 'vue'
import axios from 'axios'
import Loading from '@/vue/public/Loading.vue'
import WebinarPage from '@/vue/public/WebinarPage.vue'
import { Webinar as WebinarData } from '@/types/webinar.d'
import { useStore } from 'vuex'
import { key } from '@/vue/store'
import { useI18n } from 'vue-i18n'
import { key as i18nKey } from '@/vue/i18n'

declare global {
  interface Window {
    webinarData: WebinarData
  }
}

export default defineComponent({
  components: {
    WebinarPage,
    Loading,
  },
  setup() {
    const { t } = useI18n()
    const i18n = useStore(i18nKey)
    i18n.dispatch('init')

    const store = useStore(key)
    store.dispatch('checkAuth')

    const loginStatus = computed(() => store.state.status)

    const loading = ref(false)

    const form = ref({
      email: '',
      name: '',
    })

    const webinar = window.webinarData

    const loginForm = async () => {
      loading.value = true
      await axios.post('/login_client', {
        ...form.value,
        webinar: webinar?.id,
        utm: document.location.search,
      })
      await store.dispatch('checkAuth')
      loading.value = false
    }

    const archived = /[&|?]archived=1/.test(document.location.search)

    return {
      loginStatus,
      loading,
      loginForm,
      form,
      webinar,
      t,
      archived,
    }
  },
})
